import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type QuizConfigFragment = { completionCriteria: Types.QuizCompletionCriteriaEnum };


export type QuizConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizConfig on QuizConfigType {
  completionCriteria
}
    `;